"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
const _nocodbsdk = require("nocodb-sdk");
const _globals = require("./globals");
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
const _NocoCache = /*#__PURE__*/ _interop_require_default(require("~/cache/NocoCache"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
async function _default(force = false, ncMeta = _Noco.default.ncMeta) {
    try {
        let res = await _NocoCache.default.get('root', _globals.CacheScope.INSTANCE_META, _globals.CacheGetType.TYPE_OBJECT);
        if (!res || force) {
            var _Noco_getConfig_meta_db, _Noco_getConfig_meta, _Noco_getConfig;
            const projectsMeta = await ncMeta.knex(_globals.MetaTable.PROJECT).count('id as count').first().where('deleted', false).where('is_meta', true).then((c)=>c.count);
            const projectsExt = await ncMeta.knex(_globals.MetaTable.PROJECT).count('id as count').first().where('deleted', false).where('is_meta', false).then((c)=>c.count);
            const impacted = await ncMeta.knex(_globals.MetaTable.USERS).count('id as count').first().then((c)=>c.count);
            const created = await ncMeta.knex(_globals.MetaTable.STORE).select('created_at').where('key', 'nc_server_id').first().then((c)=>c.created_at);
            const files = await ncMeta.knex(_globals.MetaTable.FILE_REFERENCES).count('storage as count').first().then((c)=>c.count);
            const tables = await ncMeta.knex(_globals.MetaTable.MODELS).whereIn('type', [
                _nocodbsdk.ModelTypes.TABLE,
                _nocodbsdk.ModelTypes.VIEW
            ]).count('id as count').first().then((c)=>c.count);
            const views = await ncMeta.knex(_globals.MetaTable.VIEWS).count('id as count').first().then((c)=>c.count);
            const nc_db_type = (_Noco_getConfig = _Noco.default.getConfig()) == null ? void 0 : (_Noco_getConfig_meta = _Noco_getConfig.meta) == null ? void 0 : (_Noco_getConfig_meta_db = _Noco_getConfig_meta.db) == null ? void 0 : _Noco_getConfig_meta_db.client;
            res = {
                projectsMeta,
                projectsExt,
                impacted,
                nc_db_type,
                created,
                files,
                tables,
                views
            };
            await _NocoCache.default.set('root', _globals.CacheScope.INSTANCE_META, res);
        }
        return res;
    } catch (unused) {
        return {};
    }
}
